import { Network, Folder } from 'lucide-react';
import { DemoShellView } from '../mini-demo/DemoShell';
import type { DemoLayoutConfig } from '../mini-demo/types';
import { demoEntityId, DEMO_EXPANDED_PROJECT_ID } from '../demo-ids';
import { heroDirection } from './direction';

const layout: DemoLayoutConfig = {
  boundaryId: 'hero',
  workspace: 'Acme Inc.',
  breadcrumbs: [
    { label: 'Acme Inc.' },
    { label: 'Engineering', icon: Network },
    { label: 'Mobile App', icon: Folder },
  ],
  sidebar: {
    teams: [
      { id: demoEntityId('team', 1), name: 'Engineering', projects: [
        { id: demoEntityId('project', 1), name: 'Mobile App', isActive: true, children: [{ id: demoEntityId('project', 11), name: 'Auth Flow' }, { id: demoEntityId('project', 12), name: 'Dashboard' }] },
        { id: demoEntityId('project', 2), name: 'API v2', children: [] },
      ]},
      { id: demoEntityId('team', 2), name: 'Design', projects: [
        { id: demoEntityId('project', 3), name: 'Design System', children: [] },
      ]},
    ],
    expandedProjectId: DEMO_EXPANDED_PROJECT_ID,
    integrations: [
      { icon: '/github.svg', label: 'Repository', value: 'acme/mobile-app', connected: true },
      { icon: '/linear.svg', label: 'Project', value: 'Mobile App', connected: true },
      { icon: '/slack.svg', label: 'Alerts', value: '#mobile-alerts', connected: true },
    ],
  },
  columns: [
    { key: 'requirements', title: 'Requirements' },
    { key: 'questions', title: 'Questions' },
  ],
  shell: {
    className: 'absolute bottom-0 right-0 h-[90%] w-[calc(100%-20px)] max-w-[1180px] md:left-1/2 md:right-auto md:w-[95%] md:-translate-x-1/2 lg:min-w-[900px]',
    containerClassName: 'relative w-full h-full',
    roundedBottom: false,
    shadow: false,
    variant: 'macos',
    title: 'Arvid',
  },
  modal: {
    title: 'New Requirement',
    extractingMessage: 'Arvid is analyzing Slack messages...',
    composeTitlePlaceholder: 'API rate limiting for public endpoints',
    composeDescriptionPlaceholder: 'Define rate limits per API key tier with burst handling...',
  },
  showAnswers: true,
  showSummary: true,
};

export function AppDemo() {
  return <DemoShellView direction={heroDirection} layout={layout} />;
}
